import { getAnalytics, logEvent } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { getAuth, OAuthProvider, onAuthStateChanged, User } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import {
  fetchAndActivate,
  getRemoteConfig,
  getValue,
} from 'firebase/remote-config'
import { getStorage } from 'firebase/storage'

import { firebaseConfig } from '@/config'

export const firebaseApp = initializeApp(firebaseConfig)

export const auth = getAuth(firebaseApp)
export const microsoftProvider = new OAuthProvider('microsoft.com')

export const firestore = getFirestore(firebaseApp)

export const storage = getStorage(firebaseApp)
const analytics = getAnalytics(firebaseApp)

export const logAnalyticsEvent = (
  event: string,
  params?: Record<string, any>,
) => {
  logEvent(analytics, event, params)
}

export const imageStorage = getStorage(
  firebaseApp,
  `gs://${firebaseConfig.projectId}-images`,
)
export const videoStorage = getStorage(
  firebaseApp,
  `gs://${firebaseConfig.projectId}-videos`,
)

export const remoteConfig = getRemoteConfig(firebaseApp)
remoteConfig.settings.minimumFetchIntervalMillis = 1800000
fetchAndActivate(remoteConfig)

export const getConfigValue = (key: string) => {
  return getValue(remoteConfig, key)
}

export const getCurrentUser = (): Promise<User | null> => {
  return new Promise(resolve => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      unsubscribe()
      resolve(user)
    })
  })
}
